<template>
  <div class="app-body-container" style="padding-bottom: 30px">

    <!--/-->
    <div style="margin: 10px 10px">
      <el-button @click="beforeMonth">上月</el-button>
      <el-date-picker
        v-model="dateRange"
        v-loading.fullscreen.lock="reportLoading"
        type="month"
        placeholder="选择月"
        @change="getReport"
        :picker-options="pickerOptions">
      </el-date-picker>
      <!--<el-button type="primary" @click="getReport">开始统计</el-button>-->
    </div>

    <!--/-->
    <el-row class="mg-t-10">
      <el-col :span="24">
        <el-card shadow="hover" class="mycard-a">
          <el-row>
            <el-col :span="6"><p>销售总额（元）</p></el-col>
            <el-col :span="6"><p class="run">{{reportData[0].data|formatNumber}}</p></el-col>
            <el-col :span="4"><p>比上月 <span class="run">{{reportData[0].last_ratio|formatNumber}}%</span> <i :class="getCaret(reportData[0].last_ratio)"></i></p></el-col>
            <el-col :span="4"><p>年累计 <span class="run">{{reportData[0].total|formatMoney}}</span></p></el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="24" style="margin-top: 10px">
        <el-card shadow="hover" class="mycard-a">
          <el-row>
            <el-col :span="6"><p>实收总额（元）</p></el-col>
            <el-col :span="6"><p class="run">{{reportData[1].data|formatNumber}}</p></el-col>
            <el-col :span="4"><p>比上月 <span class="run">{{reportData[1].last_ratio|formatNumber}}%</span> <i :class="getCaret(reportData[1].last_ratio)"></i></p></el-col>
            <el-col :span="4"><p>年累计 <span class="run">{{reportData[1].total|formatMoney}}</span></p></el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="24" style="margin-top: 10px">
        <el-card shadow="hover" class="mycard-a">
          <el-row>
            <el-col :span="6"><p>应收欠款（元）</p></el-col>
            <el-col :span="6"><p class="run">{{reportData[2].data|formatNumber}}</p></el-col>
            <el-col :span="4"><p>比上月 <span class="run">{{reportData[2].last_ratio|formatNumber}}%</span> <i :class="getCaret(reportData[2].last_ratio)"></i></p></el-col>
            <el-col :span="4"><p>年累计 <span class="run">{{reportData[2].total|formatMoney}}</span></p></el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="24" style="margin-top: 10px">
        <el-card shadow="hover" class="mycard-a">
          <el-row>
            <el-col :span="6"><p>毛利润（元）</p></el-col>
            <el-col :span="6"><p class="run">{{reportData[3].data|formatNumber}}</p></el-col>
            <el-col :span="4"><p>比上月 <span class="run">{{reportData[3].last_ratio|formatNumber}}%</span> <i :class="getCaret(reportData[3].last_ratio)"></i></p></el-col>
            <el-col :span="4"><p>年累计 <span class="run">{{reportData[3].total|formatMoney}}</span></p></el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="24" style="margin-top: 10px">
        <el-card shadow="hover" class="mycard-a">
          <el-row>
            <el-col :span="6"><p>毛利率（元）</p></el-col>
            <el-col :span="6"><p class="run">{{reportData[4].data|formatNumber}}%</p></el-col>
            <el-col :span="4"><p>比上月 <span class="run">{{reportData[4].last_ratio|formatNumber}}%</span>  <i :class="getCaret(reportData[4].last_ratio)"></i></p></el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="24" style="margin-top: 10px">
        <el-card shadow="hover" class="mycard-a">
          <el-row>
            <el-col :span="6"><p>订单总数</p></el-col>
            <el-col :span="6"><p class="run">{{reportData[5].data|formatNumber}}</p></el-col>
            <el-col :span="4"><p>比上月 <span class="run">{{reportData[5].last_ratio|formatNumber}}%</span> <i :class="getCaret(reportData[5].last_ratio)"></i></p></el-col>
            <el-col :span="4"><p>年累计 <span class="run">{{reportData[5].total|formatNumber}}</span></p></el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="24" style="margin-top: 10px">
        <el-card shadow="hover" class="mycard-a">
          <el-row>
            <el-col :span="6"><p>销售商品种类</p></el-col>
            <el-col :span="6"><p class="run">{{reportData[6].data|formatNumber}}</p></el-col>
            <el-col :span="4"><p>比上月 <span class="run">{{reportData[6].last_ratio|formatNumber}}%</span> <i :class="getCaret(reportData[6].last_ratio)"></i></p></el-col>
            <el-col :span="4"><p>年累计 <span class="run">{{reportData[6].total|formatNumber}}</span></p></el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="24" style="margin-top: 10px">
        <el-card shadow="hover" class="mycard-a">
          <el-row>
            <el-col :span="6"><p>销售商品总量</p></el-col>
            <el-col :span="6"><p class="run">{{reportData[7].data|formatNumber}}</p></el-col>
            <el-col :span="4"><p>比上月 <span class="run">{{reportData[7].last_ratio|formatNumber}}%</span> <i :class="getCaret(reportData[7].last_ratio)"></i></p></el-col>
            <el-col :span="4"><p>年累计 <span class="run">{{reportData[7].total|formatNumber}}</span></p></el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="24" style="margin-top: 10px">
        <el-card shadow="hover" class="mycard-a">
          <el-row>
            <el-col :span="6"><p>退单总量</p></el-col>
            <el-col :span="6"><p class="run">{{reportData[8].data|formatNumber}}</p></el-col>
            <el-col :span="4"><p>比上月 <span class="run">{{reportData[8].last_ratio|formatNumber}}%</span> <i :class="getCaret(reportData[8].last_ratio)"></i></p></el-col>
            <el-col :span="4"><p>年累计 <span class="run">{{reportData[8].total|formatNumber}}</span></p></el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="24" style="margin-top: 10px">
        <el-card shadow="hover" class="mycard-a">
          <el-row>
            <el-col :span="6"><p>退款总金额</p></el-col>
            <el-col :span="6"><p class="run">{{reportData[9].data|formatNumber}}</p></el-col>
            <el-col :span="4"><p>比上月 <span class="run">{{reportData[9].last_ratio|formatNumber}}%</span> <i :class="getCaret(reportData[9].last_ratio)"></i></p></el-col>
            <el-col :span="4"><p>年累计 <span class="run">{{reportData[9].total|formatNumber}}</span></p></el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="24" style="margin-top: 10px">
        <el-card shadow="hover" class="mycard-a">
          <el-row>
            <el-col :span="6"><p>退货商品种类</p></el-col>
            <el-col :span="6"><p class="run">{{reportData[10].data|formatNumber}}</p></el-col>
            <el-col :span="4"><p>比上月 <span class="run">{{reportData[10].last_ratio|formatNumber}}%</span> <i :class="getCaret(reportData[10].last_ratio)"></i></p></el-col>
            <el-col :span="4"><p>年累计 <span class="run">{{reportData[10].total|formatNumber}}</span></p></el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="24" style="margin-top: 10px">
        <el-card shadow="hover" class="mycard-a">
          <el-row>
            <el-col :span="6"><p>退货商品总量</p></el-col>
            <el-col :span="6"><p class="run">{{reportData[11].data|formatNumber}}</p></el-col>
            <el-col :span="4"><p>比上月 <span class="run">{{reportData[11].last_ratio|formatNumber}}%</span> <i :class="getCaret(reportData[11].last_ratio)"></i></p></el-col>
            <el-col :span="4"><p>年累计 <span class="run">{{reportData[11].total|formatNumber}}</span></p></el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="24" style="margin-top: 10px">
        <el-card shadow="hover" class="mycard-a">
          <el-row>
            <el-col :span="6"><p>采购商品种类</p></el-col>
            <el-col :span="6"><p class="run">{{reportData[12].data|formatNumber}}</p></el-col>
            <el-col :span="4"><p>比上月 <span class="run">{{reportData[12].last_ratio|formatNumber}}%</span> <i :class="getCaret(reportData[12].last_ratio)"></i></p></el-col>
            <el-col :span="4"><p>年累计 <span class="run">{{reportData[12].total|formatNumber}}</span></p></el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="24" style="margin-top: 10px">
        <el-card shadow="hover" class="mycard-a">
          <el-row>
            <el-col :span="6"><p>采购商品总量</p></el-col>
            <el-col :span="6"><p class="run">{{reportData[13].data|formatNumber}}</p></el-col>
            <el-col :span="4"><p>比上月 <span class="run">{{reportData[13].last_ratio|formatNumber}}%</span> <i :class="getCaret(reportData[13].last_ratio)"></i></p></el-col>
            <el-col :span="4"><p>年累计 <span class="run">{{reportData[13].total|formatNumber}}</span></p></el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="24" style="margin-top: 10px">
        <el-card shadow="hover" class="mycard-a">
          <el-row>
            <el-col :span="6"><p>采购总金额</p></el-col>
            <el-col :span="6"><p class="run">{{reportData[14].data|formatNumber}}</p></el-col>
            <el-col :span="4"><p>比上月 <span class="run">{{reportData[14].last_ratio|formatNumber}}%</span> <i :class="getCaret(reportData[14].last_ratio)"></i></p></el-col>
            <el-col :span="4"><p>年累计 <span class="run">{{reportData[14].total|formatNumber}}</span></p></el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="24" style="margin-top: 10px">
        <el-card shadow="hover" class="mycard-a">
          <el-row>
            <el-col :span="6"><p>交易客户数</p></el-col>
            <el-col :span="6"><p class="run">{{reportData[15].data|formatNumber}}</p></el-col>
            <el-col :span="4"><p>比上月 <span class="run">{{reportData[15].last_ratio|formatNumber}}%</span> <i :class="getCaret(reportData[15].last_ratio)"></i></p></el-col>
            <el-col :span="4"><p>年累计 <span class="run">{{reportData[15].total|formatNumber}}</span></p></el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="24" style="margin-top: 10px">
        <el-card shadow="hover" class="mycard-a">
          <el-row>
            <el-col :span="6"><p>欠款客户数</p></el-col>
            <el-col :span="6"><p class="run">{{reportData[16].data|formatNumber}}</p></el-col>
            <el-col :span="4"><p>比上月 <span class="run">{{reportData[16].last_ratio|formatNumber}}%</span> <i :class="getCaret(reportData[16].last_ratio)"></i></p></el-col>
            <el-col :span="4"><p>年累计 <span class="run">{{reportData[16].total|formatNumber}}</span></p></el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="24" style="margin-top: 10px">
        <el-card shadow="hover" class="mycard-a">
          <el-row>
            <el-col :span="6"><p>退货客户数</p></el-col>
            <el-col :span="6"><p class="run">{{reportData[17].data|formatNumber}}</p></el-col>
            <el-col :span="4"><p>比上月 <span class="run">{{reportData[17].last_ratio|formatNumber}}%</span> <i :class="getCaret(reportData[17].last_ratio)"></i></p></el-col>
            <el-col :span="4"><p>年累计 <span class="run">{{reportData[17].total|formatNumber}}</span></p></el-col>
          </el-row>
        </el-card>
      </el-col>
      <el-col :span="24" style="margin-top: 10px">
        <el-card shadow="hover" class="mycard-a">
          <el-row>
            <el-col :span="6"><p>订单发货率</p></el-col>
            <el-col :span="6"><p class="run">{{reportData[18].data|formatNumber}}%</p></el-col>
            <el-col :span="4"><p>比上月 <span class="run">{{reportData[18].last_ratio|formatNumber}}%</span> <i :class="getCaret(reportData[18].last_ratio)"></i></p></el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>

  </div>
</template>

<script>
  import {formatDate} from '@/common/filters'
  export default {
    data: function () {
      return {
        dateRange:'', //日期范围
        reportLoading:false,
        reportData:[
          {},{},{},{},{},
          {},{},{},{},{},
          {},{},{},{},{},
          {},{},{},{},{}
        ],
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now();
          },
        },
      }
    },
    methods: {
      beforeMonth: function(){
          let now = new Date(); //当前日期
          let nowYear = now.getYear(); //当前年
          nowYear += (nowYear < 2000) ? 1900 : 0;
          let lastMonthDate = new Date(); //上月日期
          lastMonthDate.setDate(1);
          lastMonthDate.setMonth(lastMonthDate.getMonth()-1);
          let lastMonth = lastMonthDate.getMonth();
          function getMonthDays(myMonth){
            let monthStartDate = new Date(nowYear, myMonth, 1);
            let monthEndDate = new Date(nowYear, myMonth + 1, 1);
            let days = (monthEndDate - monthStartDate)/(1000 * 60 * 60 * 24);
            return days;
          }
          this.dateRange = new Date(nowYear, lastMonth, 1);
          this.getReport();
      },
      //时间转换
      formatDateTime(date) {
        let y = date.getFullYear();
        let m = date.getMonth() + 1;
        m = m < 10 ? ('0' + m) : m;
        return y +'-'+ m
      },
      getCaret: function(val){
          if(val>0) return 'el-icon-caret-top';
          else if(val<0) return 'el-icon-caret-bottom';
          else return ''
      },
      getReport: function(){
          let self = this;

          if (!self.dateRange) {
              self.xEui.msg_error('请选择月份')
              return;
          }
          self.reportLoading = true;
          self.xFetch.post(self.xApi('/robot/report/getMonthReport'), {
              month : self.formatDateTime(self.dateRange)
          },{xPostType:'form'}).then(function (res) {
              self.reportLoading = false;

              if (res.data.code != '00') {
                  self.xEui.msg_error(res.data.text)
                  return
              }
              if(res.data.data.length<1){
                self.xEui.msg_error('暂无数据')
              }else {
                self.reportData = res.data.data;
              }
          });
      }
    },
    created: function () {
      this.beforeMonth()
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  p{
    margin: 5px 0;
  }
  .run{
    font-size: 16px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/views/report/monthly.vue